import React, { useEffect, useState } from "react";
import { SearchBasicSelectUI } from "../../ui/SearchBasicSelectUI";
import { getMonedas } from "../../../actions/cotizacion";

export const MonedaSelect = ({ ...props }) => {
  const [monedas, SetMonedas] = useState([]);
  const OnLoadMonedas = async () => {
    const datos = await getMonedas();
    const Options = datos?.map((x) => ({
      value: x.id,
      label: x?.nombre,
      prefijo: x?.prefijo,
      prefijosunat: x?.prefijosunat,
    }));
    SetMonedas(Options);
  };
  useEffect(() => {
    OnLoadMonedas();
  }, []);

  return <SearchBasicSelectUI data={monedas} {...props} />;
};
